<template>
  <!-- 需求详情面板 -->
  <div class="request-detail">
    <splitpanes horizontal>
      <pane size="70" min-size="50" max-size="70">
        <div class="request-detail-content" ref="scrollContainer">
          <div class="detail-head">
            <div class="detail-head-title">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <h4 v-if="SidePanelData.demandNo">
                  <i class="iconfont icon-base-no"></i>需求ID：{{
                    "FW" + SidePanelData.demandNo
                  }}
                </h4>
                <el-button
                  type="text"
                  v-if="SidePanelData.demandStatus === 1"
                  @click="showDialogHandover"
                  ><i class="iconfont icon-efferent"></i>需求移交</el-button
                >

                <div v-if="this.projectId" style="flex: none">
                  <el-button type="text" @click="openProjectId"
                    >查看项目</el-button
                  >
                </div>
              </div>
            </div>
            <div
              class="detail-head-title"
              style="margin-top: 5px"
              v-if="SidePanelData.createUserName"
            >
              <div class="user-title">
                需求发起人：<span class="avatar-24"
                  ><em>{{ SidePanelData.createUserName | simplify }}</em></span
                >{{ SidePanelData.createUserName }}
              </div>
              <div>
                项目负责人：<span class="avatar-24"
                  ><em>{{ SidePanelData.chargeUserName | simplify }}</em></span
                >{{ SidePanelData.chargeUserName }}
              </div>
            </div>
            <div style="margin-top: -10px"><el-divider></el-divider></div>
          </div>
          <div class="msgChat">
            <div class="request-detail-attachment">
              <div class="demand-tool">
                <h4>需求描述</h4>
              </div>
              <div class="desc" v-html="SidePanelData.demandDescription"></div>
            </div>
            <div class="request-detail-attachment">
              <div class="demand-tool">
                <h4>需求附件</h4>
                <el-button
                  size="mini"
                  :disabled="disabled"
                  icon="el-icon-upload2"
                  @click="isShow = true"
                  v-if="!isShow"
                  >新增附件</el-button
                >
                <div>
                  <el-button
                    size="mini"
                    @click="isShow = false"
                    v-if="isShow"
                    icon="el-icon-close"
                    >取消新增</el-button
                  >
                  <el-button
                    class="upload-submit"
                    style="margin-left: 5px"
                    size="mini"
                    type="success"
                    @click="submitUpload"
                    v-if="FileList.length > 0 && isShow"
                    >上传到服务器</el-button
                  >
                </div>
              </div>
              <div style="margin-bottom: 15px">
                <div class="upload-box" v-if="isShow">
                  <el-upload
                    class="upload-demo"
                    drag
                    action=""
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="10"
                    :on-exceed="handleExceed"
                    :on-change="fileChange"
                    :auto-upload="false"
                    :file-list="FileList"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      可将文件拖到此处，或<em>点击选择</em>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="file-list" v-if="AdjunctData.length > 0">
                <div
                  v-for="(item, index) in AdjunctData"
                  :key="index"
                  class="demand-file"
                >
                  <a
                    :href="'https://fwimage.cnfanews.com/' + item.filePath"
                    target="_blank"
                  >
                    <i class="iconfont" :class="filePreview(item.filePath)"></i>
                    {{ item.filePath | fileFilter }}
                  </a>
                  <span class="tips">{{ item.created }}</span>
                </div>
              </div>
              <div v-else>
                <div style="color: #999; padding: 5px 0">暂无需求附件</div>
              </div>
            </div>
            <div class="divider">
              <el-divider></el-divider>
            </div>
            <div class="request-detail-msg" id="msg-chat">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: top;
                "
              >
                <h4>需求沟通</h4>
                <el-switch
                  v-model="historyValue"
                  active-text="仅评论"
                  inactive-text="全部"
                  @change="changeHistory"
                >
                </el-switch>
              </div>

              <div
                class="msg-item"
                v-for="(item, index) in msgListData"
                :key="index"
              >
                <div
                  v-if="
                    historyValue == true
                      ? historyValue == true && item.burialPoint === 0
                      : msgListData.length > 0
                  "
                >
                  <span class="avatar-text">{{
                    item.createUserName | simplify
                  }}</span>
                  <div class="msg-item-content">
                    <div>
                      <h3>
                        {{
                          item.createUserName ? item.createUserName : "未知"
                        }}&nbsp;<el-button
                          class="el-icon-delete"
                          type="text"
                          v-if="
                            item.createUserGUID === user.userGUID &&
                            item.burialPoint === 0 &&
                            item.isFeedBack == 0
                          "
                          @click="deleteComment(item)"
                        ></el-button>
                      </h3>
                      <div v-if="item.isFeedBack == 1" class="isFeedBack">
                        <i class="el-icon-info"></i> 该条数据为反馈内容
                      </div>
                      <div
                        v-if="item.burialPoint === 0"
                        v-html="item.comments"
                        @click="showImg($event)"
                      ></div>
                      <div v-else class="burialPoint">{{ item.comments }}</div>
                    </div>
                    <div class="msg-tips">{{ item.created }}</div>
                  </div>
                </div>
              </div>
              <div v-if="demandCommentList">
                <el-empty description="暂无评论" :image-size="100"></el-empty>
              </div>
            </div>
          </div>
        </div>
      </pane>

      <pane size="30" min-size="20" max-size="50">
        <div class="comment">
          <div class="comment-textarea">
            <!-- 普通文本框 -->
            <!-- <el-input
          type="textarea"
          resize="none"
          :rows="5"
          placeholder="请输入您的评论～"
          v-model="newMsgComments"
          size="medium"
        >
        </el-input> -->
            <!-- vue-quill-editor富文本编辑器 -->

            <quill-editor
              ref="myQuillEditor"
              class="editor"
              v-model="msgContent"
              :options="editorOption"
              :style="{
                height: 'calc(100% - 40px)',
                background: '#fff',
                borderRadius: '4px',
                border: '1px solid #ededed'
              }"
            >
            </quill-editor>
            <div class="msg-tool">
              <div></div>

              <div>
                <el-button
                  :loading="addLoading"
                  icon="el-icon-s-promotion"
                  plain
                  :disabled="disabled"
                  :type="this.choiceVisible ? 'danger' : ''"
                  @click="sendNewMsg"
                  >{{ this.choiceVisible ? "发送反馈" : "发送评论" }}</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </pane>
    </splitpanes>

    <!-- 需求移交弹窗 -->
    <el-dialog title="需求移交" :visible.sync="dialogHandover" width="420px">
      <div>
        <div>
          <h4 style="margin-bottom: 10px; font-size: 14px">
            请选择需求移交方式
          </h4>
          <el-radio-group v-model="transferDemand" style="margin-bottom: 10px">
            <el-radio :label="1">移交给其他负责人</el-radio>
            <el-radio :label="2">移交给其他项目</el-radio>
          </el-radio-group>
        </div>

        <!-- 移交给其他负责人 -->
        <div class="transfer-box" v-if="transferDemand == 1">
          <div style="color: var(--error-color)">
            <i class="el-icon-warning-outline" style="margin-right: 5px"></i
            >移交该需求给其他负责人，请谨慎操作！
          </div>
          <div>
            <el-form
              label-position="top"
              :model="formInline"
              class="demo-form-inline"
            >
              <el-form-item
                label="选择项目负责人："
                style="width: 100%; margin-top: 15px"
              >
                <el-select
                  v-model="formInline.ChargeUserGUID"
                  placeholder="选择项目负责人"
                  style="width: 100%"
                  filterable
                  @change="changeValue"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :label="item.userName"
                    :value="item.userGUID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 移交给其他项目 -->
        <div class="transfer-box" v-else>
          <div style="color: var(--error-color)">
            <i class="el-icon-warning-outline" style="margin-right: 5px"></i
            >移交该需求给项目，请谨慎操作！
          </div>
          <div>
            <el-form
              label-position="top"
              :model="formInlineProject"
              class="demo-form-inline"
            >
              <el-form-item
                label="请输入项目编号："
                style="width: 100%; margin-top: 15px"
              >
                <el-input
                  v-model="formInlineProject.input"
                  placeholder="请输入项目编号"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogHandover = false">取 消</el-button>
        <el-button type="danger" @click="ConfirmHandover">确定移交</el-button>
      </span>
    </el-dialog>
    <!-- 需求评论中的图片预览 -->
    <el-image-viewer
      v-if="imgShow"
      :on-close="closeViewer"
      :url-list="previewImgList"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";

import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { Splitpanes, Pane } from "splitpanes"; // 左右栏拖拽缩放

import { syncGetToken } from "@/utils/auth";
// import eventBus from "@/pages/EventBus";
import { checkFileType } from "@/filters/index.js";

import {
  GetDemandCommunicationManagementPageList,
  AddDemandCommunicationManagement,
  GetDemandAdjunctManagementPageList,
  ReceiveDemandManagement,
  CloseDemandManagement,
  AddDemandAdjunctManagement,
  DeleteDemandCommunicationManagement,
  HandoverDemandManagement,
  GetUserByDepartList,
  HandoverDemandManagementToProject
} from "@/api/index.js";

import { quillEditor, Quill } from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme

import { ImageExtend } from "quill-image-super-solution-module";

Quill.register("modules/ImageExtend", ImageExtend);

// 获取token
let token = "";
syncGetToken().then(
  (acessToken) => {
    token = acessToken.token;
  },
  (err) => {
    console.log(err);
  }
);

export default {
  computed: {
    ...mapState(["msgComment"]),
    ...mapGetters(["user"])
  },
  props: ["SidePanelData", "projectId", "showChoice", "disabled"],
  components: {
    quillEditor,
    ElImageViewer,
    Splitpanes,
    Pane
  },
  data() {
    return {
      transferDemand: 1,
      msgContent: "",
      content: "",
      editorOption: {
        // 富文本编辑器配置，顶部的工具栏
        modules: {
          ImageExtend: {
            // 可选参数 是否显示上传进度和提示语
            // Optional parameters. Whether to display upload progress and prompt
            loading: false,
            // 图片参数名
            // Picture parameter name
            name: "FilePath_Upload",
            // 可选参数 图片大小，单位为M，1M = 1024kb
            // Optional parameters. Image size, Unit is M
            size: 1,
            // 服务器地址, 如果action为空，则采用base64插入图片
            // Server address, if action is empty, use base64 to insert picture
            action:
              window.SERVERAPI.API_BASE +
              "/P_DemandCommunicationManagement/AddDemandAdjunctManagementUploadImg",
            // 可选 可上传的图片格式
            // Optional, uploadable image format
            accept: "image/jpg, image/png, image/gif, image/jpeg",
            // response 为一个函数用来获取服务器返回的具体图片地址
            // response is a function to get the specific image address returned by the server
            // 例如服务器返回 {code: 200; data:{ url: 'baidu.com'}}
            // For example, the server returns {code: 200; data:{ url: 'baidu.com'}}
            // 则 return res.data.url
            response: (res) => {
              if (res.data.length > 0) {
                return res.data[0].filePath;
              } else {
                this.$message({
                  message: "仅支持图片截图上传",
                  type: "warning"
                });
                this.msgContent = "";
              }
            },
            // 可选参数 设置请求头部
            // Optional parameter. Set request header
            headers: (xhr) => {
              // 比如添加 csrf-token
              // For example, add csrf-token
              xhr.setRequestHeader("Authorization", "Bearer " + token);
            },
            // 图片超过大小的回调
            // Callback when the image exceeds the size
            sizeError: () => {
              alert("图片大小超过 1 M");
            },
            // 可选参数 自定义开始上传触发事件
            // Optional parameters. Custom start upload trigger event
            start: () => {},
            // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            // Optional parameters. Customize the event triggered by the end of upload, regardless of success or failure
            end: () => {},
            // 可选参数 上传失败触发的事件
            // Optional parameter. The event triggered by upload failure
            error: () => {},
            // 可选参数  上传成功触发的事件
            // Optional parameter. The event triggered by a successful upload
            success: () => {},
            // 可选参数 选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
            // Optional parameters. Select the picture to trigger. It can also be used to set the header, but there is one more parameter than headers, which can be set formData
            change: (xhr, formData) => {
              formData.append("DemandId", this.DemandId);
              // formData.append("FilePath_Upload", "test");
            }
          },
          toolbar: {
            container: [
              // [{ size: ["small", false, "large", "huge"] }], // 字体大小工具栏
              ["bold", "italic", "underline", "strike"], // // 加粗 斜体 下划线 删除线
              [{ color: [] }, { background: [] }] // 字体颜色、字体背景颜色
            ]
            // handlers: {
            //   image: function () {
            //     // 劫持原来的图片点击按钮事件
            //     // Hijack the original picture click button event
            //     QuillWatch.emit(this.quill.id);
            //   }
            // }
          }
        },
        theme: "bubble", // 主题   snow 有工具栏 bubble 无工具栏
        placeholder: "在这里输入评论内容..."
      },

      demandStatus: 1,
      newMsgComments: "",
      // detailBtn: false, // 任务详情按钮

      msgList: [],

      // 需求沟通
      msgListData: [],
      pageCurrent: 1,
      pageLimit: 10,
      DemandId: "",
      AdjunctData: [],

      FileList: [],
      historyValue: true,
      isShow: false,

      dialogHandover: false, // 需求移交弹窗
      formInline: {},
      formInlineProject: {},
      options: [],

      demandCommentList: false,

      imgShow: false,
      previewImgList: [], // 预览图片路径

      addLoading: false, // 发送评论loading

      choiceVisible: false, // 当前是否为普通状态或者 需求反馈状态
      IsFeedBack: 0 // 提交的时候参数 是否是反馈  0 不是 1是
    };
  },
  activated() {},

  watch: {
    SidePanelData(newVal, oldVal) {
      // console.log("@@@", newVal);
      this.DemandId = this.SidePanelData.id;
      this.msgListData = [];
      this.getMsgList(this.SidePanelData.id);
      this.getAdjunct(); // 需求附件
      this.$nextTick(() => {
        if (this.$refs.scrollContainer) {
          this.$refs.scrollContainer.scrollTop = 0;
        }
      });

      this.choiceVisible = false;
      this.IsFeedBack = 0;
    }
  },
  created() {},
  mounted() {
    this.initDetail();
  },
  methods: {
    initDetail() {
      if (this.SidePanelData.id) {
        this.DemandId = this.SidePanelData.id; // 进入的时候获得需求ID

        this.getMsgList(this.SidePanelData.id);
        this.getAdjunct();
      }
    },

    closeViewer() {
      this.imgShow = false;
      this.previewImgList = [];
    },
    showImg(e) {
      // console.log(e);
      if (e.target.nodeName === "IMG") {
        this.previewImgList.push(e.target.currentSrc);
        // console.log(this.previewImgList);
        this.imgShow = true;
      }
    },
    handelContent(str) {
      if (str) {
        return (str =
          "<p>" +
          str.replace(/ /g, "&nbsp;").replace(/\n|\r\n/g, "</p><p>") +
          "<p>");
      }
    },
    changeState() {
      this.SidePanelData.demandStatus = 2;
    },
    receiveDemand(id) {
      let params = {
        Id: id
      };
      this.$confirm("确认接收该条需求？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        ReceiveDemandManagement(params)
          .then((res) => {
            this.$message({
              message: "该需求已接收",
              type: "success"
            });
            this.SidePanelData.demandStatus = 1;
          })
          .catch((err) => {
            console.warn(err);
          });
      });
    },
    closeDemand(id) {
      let params = {
        Id: id
      };
      this.$confirm("确认关闭该条需求？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        CloseDemandManagement(params)
          .then((res) => {
            this.$message({
              message: "该需求已关闭",
              type: "success"
            });
            this.SidePanelData.demandStatus = 4;
          })
          .catch((err) => {
            console.warn(err);
          });
      });
    },
    openTaskDetail() {
      const routeUrl = this.$router.resolve({
        path: "/project/split",
        query: {
          demandNo: this.SidePanelData.demandNo,
          id: this.SidePanelData.id,
          title: "1",
          parentId: 0,
          chargeUserGUID: this.SidePanelData.chargeUserGUID
        }
      });
      window.open(routeUrl.href, "_blank");
    },

    openTask() {
      // console.log(this.SidePanelData);
      const routeUrl = this.$router.resolve({
        path: "/project/split",
        query: {
          title: "1",
          parentId: 0,
          demandNo: this.SidePanelData.demandNo,
          id: this.SidePanelData.id,
          chargeUserGUID: this.SidePanelData.chargeUserGUID
        }
      });
      window.open(routeUrl.href, "_blank");
    },

    deleteComment(row) {
      this.$confirm("确认删除该条评论？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // console.log(row.id);

        DeleteDemandCommunicationManagement({ Id: row.id }).then((res) => {
          this.$message.success("评论数据删除成功!");
          this.msgListData = this.msgListData.filter((item) => {
            return item.id !== row.id;
          });
        });
      });
    },

    scrollToBottom() {
      // 获取聊天框元素
      this.$nextTick(() => {
        const scrollDiv = this.$refs.scrollContainer;
        // const scrollHeight = scrollDiv.scrollHeight;
        scrollDiv.scrollTop = scrollDiv.scrollHeight - scrollDiv.clientHeight;
      });
    },

    // sendNewMsg() {
    //   if (this.newMsg) {
    //     this.msgList.push({
    //       userName: "李四",
    //       msg: this.newMsg,
    //       assigned: "2023-06-14 18:00:00",
    //       date: "2023-06-14"
    //     });

    //     this.newMsg = "";
    //     setTimeout(() => {
    //       this.scrollToBottom();
    //     }, 100);
    //   } else {
    //     this.$message({
    //       message: "请输入评论内容后发送",
    //       type: "warning"
    //     });
    //   }
    // },

    // 获取全部沟通评论数据
    getMsgList(id) {
      let params = {
        page: this.pageCurrent,
        pageSize: 9999,
        DemandId: id
      };
      GetDemandCommunicationManagementPageList(params)
        .then((res) => {
          this.msgListData = res.data.data;

          if (res.data.data.some((item) => item.burialPoint === 0)) {
            this.demandCommentList = false;
          } else {
            this.demandCommentList = true;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    // 需求附件
    getAdjunct() {
      if (this.SidePanelData.id) {
        let params = {
          page: 1,
          pageSize: 999,
          DemandId: this.SidePanelData.id
        };
        GetDemandAdjunctManagementPageList(params)
          .then((res) => {
            this.AdjunctData = res.data.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      }
    },

    // 发送消息后重新获取最新的一条数据
    getMsgLast() {
      let params = {
        page: this.pageCurrent,
        pageSize: 9999,
        DemandId: this.SidePanelData.id
      };
      GetDemandCommunicationManagementPageList(params)
        .then((res) => {
          // burialPoint 1 是埋点     0是评论
          let lastMsg = "";

          if (res.data.data[res.data.data.length - 1].burialPoint === 1) {
            lastMsg = res.data.data[res.data.data.length - 2];
            this.getAdjunct(); // 发送反馈后 重新获取附件
          } else {
            lastMsg = res.data.data[res.data.data.length - 1];
          }
          this.msgListData.push(lastMsg);
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    ...mapMutations("msgComment", ["RESET"]),

    // 发送消息
    sendNewMsg() {
      if (this.msgContent) {
        this.addLoading = true;

        let imgTags = this.msgContent.match(/<img.*?src="(.*?)".*?>/g);
        let srcUrls = [];
        if (imgTags) {
          srcUrls = imgTags
            .map((imgTag) => imgTag.match(/src="(.*?)"/)[1])
            .join(",");
        }

        let data = {
          DemandId: this.DemandId,
          Comments: this.msgContent,
          FilePath: srcUrls,
          IsFeedBack: this.IsFeedBack,
          FeedBackFilePath: this.msgComment.filePath
        };
        AddDemandCommunicationManagement(data)
          .then((res) => {
            // this.msgComment.msgData = "";
            // this.msgComment.filePath = "";
            if (res) {
              this.RESET(); // 清空选择的任务评论和任务附件数据
              this.IsFeedBack = 0; // 重置
              this.choiceVisible = false; // 重置 当前是否为普通状态或者 需求反馈状态

              this.msgContent = "";
              this.addLoading = false;
              this.demandCommentList = false; // 暂无评论空图标 隐藏

              setTimeout(() => {
                this.getMsgLast();
                this.scrollToBottom();
                this.$message.success("评论已发布");
              }, 100);
            }
          })
          .catch((err) => {
            console.warn(err);
            this.addLoading = false;
          })
          .finally((res) => {
            this.addLoading = false;
          });
      } else {
        this.$message({
          message: "请输入评论内容后发送",
          type: "warning"
        });
      }
    },

    // 开启需求反馈
    feedback() {
      this.IsFeedBack = 1;
      this.choiceVisible = true;
      this.$emit("choiceContent", true);
      // this.feedbackVisible = true;
      // 打开任务列表
    },

    // 关闭反馈
    closeFeedback() {
      this.IsFeedBack = 0;
      this.choiceVisible = false;

      this.$emit("closeFeedback", false);
      this.RESET(); // 清空选择的任务评论和任务附件数据
    },

    filePreview(fileUrl) {
      const result = checkFileType(fileUrl);
      // console.log(result.iconClass);
      return result.iconClass;
    },

    // 上传事件
    handleRemove(file, fileList) {
      this.FileList = fileList;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次已选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    fileChange(file, list) {
      this.FileList = list;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确认移除 ${file.name}？`);
    },

    submitUpload() {
      // console.log(this.SidePanelData.demandNo);
      let data = {
        DemandId: this.DemandId
      };

      let formData = new FormData();
      formData.append("DemandId", data.DemandId);
      // console.log(this.FileList);
      this.FileList.forEach((item) => {
        formData.append("filePath_Upload", item.raw);
      });

      AddDemandAdjunctManagement(formData)
        .then((res) => {
          // console.log(res);
          this.isShow = false;

          this.$message({
            message: "需求附件新增成功",
            type: "success"
          });
          this.FileList = [];
          this.getAdjunct();
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    changeHistory(val) {
      this.historyValue = val;
    },

    // 删除需求附件
    // deleteFile(data) {
    //   // this.taskDetail.fileList = this.taskDetail.fileList.filter(item => {
    //   //   return item.id !== data.id
    //   // })
    //   // return
    //   this.$confirm(`确认删除 ${data.fileName} 文件吗？`, "提示", {
    //     confirmButtonText: "确认",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then((res) => {
    //       AddDemandAdjunctManagement({ DemandId: data.id }).then((res) => {
    //         this.taskDetail.fileList = this.taskDetail.fileList.filter(
    //           (item) => {
    //             return item.id !== data.id;
    //           }
    //         );
    //         this.$message.success("已删除该文件");
    //       });
    //     })
    //     .catch(() => {
    //       this.$message.info("取消删除");
    //     });
    // }

    showDialogHandover() {
      this.dialogHandover = true;
      GetUserByDepartList({ departId: "2792,281,2794" })
        .then((res) => {
          this.options = res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    changeValue(val) {
      this.formInline.ChargeUserGUID = val;
    },

    ConfirmHandover() {
      if (this.transferDemand === 1) {
        let params = {
          Id: this.SidePanelData.id,
          ChargeUserGUID: this.formInline.ChargeUserGUID
        };
        HandoverDemandManagement(params)
          .then((res) => {
            this.$emit("refresh");

            this.$message({
              message: "该需求已移交",
              type: "success"
            });
          })
          .catch((err) => {
            console.warn(err);
          })
          .finally(() => {
            this.dialogHandover = false;
          });
      } else {
        let params = {
          Id: this.SidePanelData.id,
          ProjectNo: this.formInlineProject.input.replace("FW", "")
        };
        HandoverDemandManagementToProject(params)
          .then((res) => {
            this.$emit("refresh");
            this.$message({
              message: "该需求已移交",
              type: "success"
            });
          })
          .catch((err) => {
            console.warn(err);
          })
          .finally(() => {
            this.dialogHandover = false;
          });
      }
    },

    // 全文检索中查看项目
    openProjectId() {
      let row = {
        projectId: this.projectId
      };
      this.$emit("openInfo", row);
    },

    filling() {
      this.msgContent = this.msgComment.msgData;
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  animation: rtl-drawer-in 0.5s ease-in-out 0.2s;
}

.fade-enter,
.fade-leave-to {
  animation: rtl-drawer-in 0.5s ease-in-out 0.2s;
  // opacity: 0;
}

@keyframes fn-fade-in {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes rtl-drawer-in {
  0% {
    transform: translate(30%);
    opacity: 0;
  }

  to {
    transform: translate(0);
    opacity: 1;
  }
}

.burialPoint {
  font-size: 12px !important;
  color: var(--text-tips) !important;
}

.upload-box {
  position: relative;
  .upload-submit {
    margin-left: 10px;
    position: absolute;
    top: 0;
    left: 95px;
  }
}

/deep/ .upload-demo {
  width: 100%;

  .el-upload {
    width: 100%;
    display: flex;
    align-items: center;

    .el-upload-dragger {
      width: 100%;
      height: 120px;
    }
  }
}

.el-icon-upload {
  margin: 20px 0 0px;
}
.demand-tool {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  h4 {
    padding-bottom: 0 !important;
    flex: 1;
  }
}
.demand-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 32px;
  a {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span {
    width: 150px;
    text-align: right;
  }
}

.el-select-dropdown__item:last-child {
  margin-bottom: 20px;
}
.previewImg {
  position: fixed;
  inset: 0;
}
.icon-efferent {
  font-size: 12px;
  margin-right: 5px;
}

.isFeedBack {
  font-size: 12px;
  color: var(--error-color);
  padding: 5px 0;
}
.transfer-box {
  padding: 20px;
  background: var(--bg2);
  margin-top: 10px;
}

/deep/.splitpanes {
  background-color: #fff;

  &__pane {
    justify-content: center;
    align-items: center;
    display: flex;
  }

  &__splitter {
    background-color: #f4f6f8;
    position: relative;
    min-height: 2px;
    cursor: col-resize;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      transition: 0.4s;
    }
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }

  &--vertical > &__splitter:before {
    left: -30px;
    right: -30px;
    height: 100%;
  }

  &__splitter:hover:before {
    background-color: var(--brand);
  }
}

.request-detail-content {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  transition: all 0.3s ease 0s;
  .detail-head {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 9;
  }
}
.request-detail-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.request-detail-content::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.08);
}

.request-detail-content::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
}

.msg-tool {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

// 右侧面板样式
.request-detail {
  background-color: #fff;
  position: relative;
  width: 100%;
  height: 100%;
  h4 {
    font-size: 16px;
  }
  a {
    color: var(--brand);
    &:hover {
      color: var(--text-link);
      text-decoration: underline;
    }
  }
}
.detail-head {
  padding: 20px 20px 0;
  position: sticky;
  .detail-head-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 32px;
    font-size: 14px;
    color: var(--text-1);
    > div {
      flex: 1;
    }
  }
}
.request-detail-attachment {
  padding: 0 20px;
  .desc {
    color: var(--text-1);
    margin-bottom: 30px;
    line-height: 1.6;
  }
  h4 {
    padding-bottom: 15px;
    &::before {
      content: "■";
      color: #fa8101;
      margin-right: 5px;
      display: inline-block;
      font-size: 12px;
      transform: scale(0.6);
    }
  }
  .file-list {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;

    .file-item {
      display: flex;
      justify-content: space-between;
      padding: 5px 0;
      a {
        display: block;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--brand);
      }

      span:nth-child(2) {
        color: var(--text-2);
      }
    }
  }
}

.request-detail-msg {
  padding: 0 20px;
  h4 {
    padding-bottom: 15px;
    position: relative;
    &::before {
      content: "■";
      color: #fa8101;
      margin-right: 5px;
      display: inline-block;
      font-size: 12px;
      transform: scale(0.6);
    }
  }
}
.msg-item {
  > div {
    display: flex;
    justify-content: space-between;
    align-items: top;
    margin-bottom: 20px;
    .msg-item-content {
      flex: 1;
      h3 {
        font-size: 15px;
        color: var(--text-1);
      }
      p {
        font-size: 14px;
        color: var(--text-1);
        padding: 3px 0;
        word-break: break-all;
      }
      img {
        max-width: 100%;
        border-radius: 2px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        &:hover {
          box-shadow: 0 0 0 2px #ededed;
        }
      }
      .msg-tips {
        font-size: 12px;
        color: var(--text-tips);
      }
    }
    .msg-item-date {
      color: var(--text-tips);
    }
  }
  &:last-child {
    margin-bottom: 120px;
  }
}
.avatar-text {
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 32px;
  display: block;
  text-align: center;
  color: var(--brand);
  background: #e6f7ff;
  font-size: 12px;
  font-weight: 500;
  margin-right: 6px;
  flex-shrink: 0;
}
.comment {
  width: 100%;
  height: 100%;
  text-align: center;
  border-top: 1px solid var(--color-border);
  z-index: 9;
}
.comment-textarea {
  height: 100%;
  padding: 10px;
  background-color: var(--bg);
}
.comment-tool {
  padding: 10px;
  border-top: 1px solid #ededed;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.icon-base-no {
  font-weight: 400;
  margin-right: 10px;
  color: var(--brand);
}

.divider {
  padding: 0 20px;
  .el-divider--horizontal {
    margin: 15px 0;
  }
}

.tips {
  color: var(--text-tips) !important;
}

.search-input {
  padding: 0 0 10px;
}

.avatar-24 {
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  display: inline-block;
  border-radius: 26px;
  color: var(--brand);
  background-color: #e6f7ff;
  margin-right: 5px;
  em {
    font-size: 12px;
    font-style: normal;
    display: block;
    transform: scale(0.8);
    transform-origin: center center;
  }
}
</style>
